<template>
  <!-- eslint-disable vue/valid-v-slot -->
  <v-card class="pa-6" flat>
    <v-row class="mt-2 mr-2">
      <v-btn
        icon
        class="hidden-xs-only ml-3"
        color="primary"
        @click="$router.push('/dashboard')"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <p class="text-h5 bold ml-4">TURMAS</p>
      <v-spacer />
      <v-dialog
        v-model="dialog"
        persistent
        :max-width="$vuetify.breakpoint.mdAndDown ? '' : '40vw'"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="bold"
            color="secondary"
            large
            rounded
            v-bind="attrs"
            v-on="on"
            @click="dialog = true"
          >
            <v-icon>mdi-plus</v-icon>
            <span class="login pa-2">NOVA TURMA</span>
          </v-btn>
        </template>
        <v-form ref="newTeamForm" v-model="valid" lazy-validation>
          <v-card>
            <v-toolbar color="primary" dark>Nova Turma</v-toolbar>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col>
                    <v-text-field
                      v-model="form.name"
                      label="Nome*"
                      required
                      :rules="stringRules"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="form.source"
                      label="Descrição*"
                      required
                      :rules="stringRules"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="form.year"
                      label="Ano*"
                      required
                      :rules="stringRules"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="form.whatsappUrl"
                      label="Link do Whatsapp"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="blue darken-1" text @click="closeModal">
                Fechar
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="edit ? editTeam() : createTeam()"
              >
                Salvar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-row>

    <v-data-table class="mt-12" :headers="headers" :items="teams">
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon large v-bind="attrs" v-on="on" @click="openEdit(item)">
              <v-icon> mdi-pencil-outline </v-icon>
            </v-btn>
          </template>
          <span>Editar turma</span>
        </v-tooltip>

        <v-dialog
          v-model="modalStudent"
          persistent
          :max-width="$vuetify.breakpoint.mdAndDown ? '' : '70vw'"
        >
          <template v-slot:activator="{ on: onDialog, attrs: attrsDialog }">
            <v-tooltip top>
              <template
                v-slot:activator="{ on: onTooltip, attrs: attrsTooltip }"
              >
                <v-btn
                  icon
                  large
                  v-bind="{ ...attrsDialog, ...attrsTooltip }"
                  @click="openModalStudent(item)"
                  v-on="{ ...onDialog, ...onTooltip }"
                >
                  <v-icon> mdi-account-multiple-outline </v-icon>
                </v-btn>
              </template>
              <span>Editar usuários</span>
            </v-tooltip>
          </template>
          <v-card>
            <v-toolbar color="primary" dark
              >Educandos vinculados a turma</v-toolbar
            >
            <v-card-text>
              <br />
              <p>
                *Selecione os usuários a serem vinculados a turma clicando no
                checkbox disponível em cada linha da tabela.
              </p>

              <v-data-table
                v-model="selectedStudents"
                class="mt-12"
                item-key="id"
                :headers="headersStudent"
                :items="users"
                show-select
                @item-selected="onSelectStudent"
              >
                <template v-slot:header.data-table-select> </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="blue darken-1" text @click="closeModalStudent">
                Fechar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              large
              v-bind="attrs"
              v-on="on"
              @click="deleteTeam(item)"
            >
              <v-icon> mdi-delete-outline </v-icon>
            </v-btn>
          </template>
          <span>Excluir turma</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';

// eslint-disable-next-line import/no-cycle
import {
  getClass,
  getClassById,
  createClass,
  editClass,
  removeClass,
  createUserClass,
  deleteUserClass,
} from '@/services/class';

// eslint-disable-next-line import/no-cycle
import { getUsers } from '@/services/user';

import { stringRules } from '@/utils/Rules';

export default {
  name: 'Teams',
  data: () => ({
    stringRules,
    edit: false,
    valid: false,
    dialog: false,
    form: {
      name: '',
      source: '',
      year: '',
      whatsappUrl: '',
    },
    selectedStudents: [],
    headers: [
      {
        text: 'Código',
        align: 'start',
        filterable: true,
        value: 'id',
        class: 'primary',
      },
      {
        text: 'Nome',
        align: 'start',
        filterable: true,
        value: 'name',
        class: 'primary',
      },
      {
        text: 'Descrição',
        align: 'start',
        filterable: true,
        value: 'source',
        class: 'primary',
      },
      {
        text: 'Ano',
        align: 'start',
        filterable: true,
        value: 'year',
        class: 'primary',
      },
      {
        text: 'Link do Whatsapp',
        align: 'start',
        filterable: true,
        value: 'whatsappUrl',
        class: 'primary',
      },
      { text: 'Ações', value: 'actions', sortable: false, class: 'primary' },
    ],
    teams: [],
    modalStudent: false,
    teamsStudent: [],
    headersStudent: [
      {
        text: 'Nome',
        align: 'start',
        filterable: true,
        value: 'firstName',
        class: 'primary',
      },
      {
        text: 'Sobrenome',
        align: 'start',
        filterable: true,
        value: 'lastName',
        class: 'primary',
      },
      {
        text: 'CPF',
        align: 'start',
        filterable: true,
        value: 'cpf',
        class: 'primary',
      },
      {
        text: 'Perfil',
        align: 'start',
        filterable: true,
        value: 'profile.description',
        class: 'primary',
      },
    ],
    users: [],
  }),
  mounted() {
    this.getTeams();
  },
  methods: {
    ...mapActions('loading', ['showLoading', 'hideLoading']),
    async getUsers() {
      try {
        this.showLoading();
        const { data } = await getUsers({ name: '', profileId: '' });

        this.users = data.rows;
      } catch (e) {
        if (this.$root.vtoast) {
          this.$root.vtoast.show({
            message: 'Erro ao buscar usuários.',
            top: true,
            right: true,
            show: true,
            color: 'error',
          });
        }
      } finally {
        this.hideLoading();
      }
    },
    async getTeams() {
      try {
        this.showLoading();
        const { data } = await getClass();

        this.teams = data;
      } catch (e) {
        if (this.$root.vtoast) {
          this.$root.vtoast.show({
            message: 'Erro ao buscar as turmas.',
            top: true,
            right: true,
            show: true,
            color: 'error',
          });
        }
      } finally {
        this.hideLoading();
      }
    },
    async getTeamById(id) {
      try {
        this.showLoading();
        const { data } = await getClassById(id);
        this.selectedStudents = data.users;
      } catch (e) {
        if (this.$root.vtoast) {
          this.$root.vtoast.show({
            message: 'Erro ao buscar os usuários vinculados a turma.',
            top: true,
            right: true,
            show: true,
            color: 'error',
          });
        }
      } finally {
        this.hideLoading();
      }
    },
    async createTeam() {
      try {
        this.showLoading();
        const resp = await createClass(this.form);
        if (resp && resp.success) {
          this.$root.vtoast.show({
            message: `Turma ${this.form.name} adicionada com sucesso.`,
            top: true,
            right: true,
            show: true,
            color: 'success',
          });
          this.closeModal();
          this.getTeams();
        } else {
          this.$root.vtoast.show({
            message: 'Erro ao criar a turma.',
            top: true,
            right: true,
            show: true,
            color: 'error',
          });
        }
      } catch (e) {
        this.$root.vtoast.show({
          message: 'Erro ao criar a turma.',
          top: true,
          right: true,
          show: true,
          color: 'error',
        });
      } finally {
        this.hideLoading();
      }
    },
    openEdit(item) {
      this.dialog = true;
      this.form = item;
      this.edit = true;
    },
    async editTeam() {
      try {
        this.showLoading();
        const resp = await editClass(this.form);
        if (resp && resp.success) {
          this.$root.vtoast.show({
            message: `Turma ${this.form.name} editada com sucesso.`,
            top: true,
            right: true,
            show: true,
            color: 'success',
          });
          this.closeModal();
          this.form = {
            name: '',
            source: '',
            year: '',
            whatsappUrl: '',
          };
          this.getTeams();
        } else {
          this.$root.vtoast.show({
            message: 'Erro ao editar a turma.',
            top: true,
            right: true,
            show: true,
            color: 'error',
          });
        }
      } catch (e) {
        this.$root.vtoast.show({
          message: 'Erro ao editar a turma.',
          top: true,
          right: true,
          show: true,
          color: 'error',
        });
      } finally {
        this.hideLoading();
      }
    },
    async deleteTeam(item) {
      try {
        this.showLoading();
        await removeClass(item);
        this.$root.vtoast.show({
          message: `Turma ${this.form.name} excluída com sucesso.`,
          top: true,
          right: true,
          show: true,
          color: 'success',
        });
        this.closeModal();
        this.form = {
          name: '',
          source: '',
          year: '',
          whatsappUrl: '',
        };
        this.getTeams();
      } catch (e) {
        this.$root.vtoast.show({
          message: 'Erro ao excluir a turma.',
          top: true,
          right: true,
          show: true,
          color: 'error',
        });
      } finally {
        this.hideLoading();
      }
    },
    closeModal() {
      this.dialog = false;
      this.edit = false;
      this.form = {
        name: '',
        source: '',
        year: '',
        whatsappUrl: '',
      };
    },
    openModalStudent(item) {
      this.modalStudent = true;
      this.form = item;
      this.getUsers();
      this.getTeamById(item.id);
    },
    async onSelectStudent({ item, value }) {
      if (value === true) {
        try {
          this.showLoading();
          await createUserClass({
            userId: item.id,
            classId: this.form.id,
          });
          this.$root.vtoast.show({
            message: `Usuário vinculado a turma com sucesso.`,
            top: true,
            right: true,
            show: true,
            color: 'success',
          });
        } catch (e) {
          this.$root.vtoast.show({
            message: 'Erro ao criar o vínculo entre usuário e turma.',
            top: true,
            right: true,
            show: true,
            color: 'error',
          });
        } finally {
          this.hideLoading();
        }
      } else {
        try {
          this.showLoading();
          await deleteUserClass({
            userId: item.id,
            classId: this.form.id,
          });
          this.$root.vtoast.show({
            message: `Usuário desvinculado a turma com sucesso.`,
            top: true,
            right: true,
            show: true,
            color: 'success',
          });
        } catch (e) {
          this.$root.vtoast.show({
            message: 'Erro ao desvincular usuário e turma.',
            top: true,
            right: true,
            show: true,
            color: 'error',
          });
        } finally {
          this.hideLoading();
        }
      }
    },
    closeModalStudent() {
      this.modalStudent = false;
      this.form = {
        name: '',
        source: '',
        year: '',
        whatsappUrl: '',
      };
    },
  },
};
</script>

<style scoped>
.bold {
  font-weight: bold;
}

*
  >>> .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  background-color: #137cc0;
  color: white;
}

*
  >>> .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th:hover {
  color: white;
}

* >>> .mdi-arrow-up::before {
  color: white;
}
</style>
